<template>
    <div>
        <form @submit.prevent="save">
            <div class="modal-card" v-show="!isLoading">
                <header class="modal-card-head">
                    <p class="modal-card-title">Detalii</p>
                </header>
                <section class="modal-card-body">
                    
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Autovehicul</label>
                        </div>
                        <div class="field-body">
                            <div class="field is-narrow">
                                <div class="control">
                                    <div class="select is-fullwidth">
                                        <select v-model="expense.vehicleId">
                                            <option value>
                                                Alege autovehicul
                                            </option>
                                            <option
                                                v-for="v in vehiclesList"
                                                :key="v.id"
                                                :value="v.id"
                                            >
                                                {{ v.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <p
                                        class="help is-danger"
                                        v-if="
                                            $v.expense.vehicleId.$dirty &&
                                            !$v.expense.vehicleId.required
                                        "
                                    >
                                        Alege autovehiculul
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">Categorie</label>
                    </div>
                    <div class="field-body">
                      <div class="field is-narrow">
                        <div class="control">
                          <div class="select is-fullwidth">
                            <select
                                autofocus
                                v-model="expense.expenseTypeId"
                            >
                              <option value>Alege categoria</option>
                              <option
                                  v-for="t in eTypes"
                                  :key="t.name"
                                  :value="t.id"
                              >
                                {{ t.name }}
                              </option>
                            </select>
                          </div>
                          <p
                              class="help is-danger"
                              v-if="
                                  $v.expense.expenseTypeId.$dirty &&
                                  !$v.expense.expenseTypeId.required
                              "
                          >
                            Alege categoria
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Plata</label>
                        </div>
                        <div class="field-body">
                            <div class="field is-narrow">
                                <div class="control">
                                    <div class="select is-fullwidth">
                                        <select
                                            autofocus
                                            v-model="expense.paymentType"
                                        >
                                            <option value>Alege tip plata</option>
                                            <option
                                                v-for="t in pTypes"
                                                :key="t.name"
                                                :value="t.name"
                                            >
                                                {{ t.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <p
                                        class="help is-danger"
                                        v-if="
                                            $v.expense.paymentType.$dirty &&
                                            !$v.expense.paymentType.required
                                        "
                                    >
                                        Alege tipul
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Furnizor</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <p class="control">
                                    <b-autocomplete
                                        v-model="providerSearch"
                                        :data="filteredProviders"
                                        placeholder="Cauta furnizor (min 3 caractere)..."
                                        field="name"
                                        :loading="isLoadingProviders"
                                        @typing="onProviderTyping"
                                        @select="onProviderSelect"
                                        @keyup.native.enter="onProviderEnter"
                                        :open-on-focus="false"
                                        clearable
                                        autocomplete="off"
                                    >
                                        <template slot-scope="props">
                                            <div class="media">
                                                <div class="media-content">
                                                    {{ props.option.name }}
                                                    <br>
                                                    <small v-if="props.option.cui">CUI: {{ props.option.cui }}</small>
                                                </div>
                                            </div>
                                        </template>
                                        <template #empty>
                                            <span v-if="providerSearch.length >= 3">Nu s-a gasit niciun furnizor.</span>
                                            <span v-else>Tasteaza minim 3 caractere pentru cautare.</span>
                                        </template>
                                        <template #footer>
                                            <a @click="addNewProvider">
                                                <span class="icon is-small">
                                                    <i class="fa fa-plus-circle"></i>
                                                </span>
                                                <span>Adauga furnizor nou</span>
                                            </a>
                                        </template>
                                    </b-autocomplete>
                                </p>
                                <p
                                    class="help is-danger"
                                    v-if="
                                        $v.expense.providerId.$dirty &&
                                        !$v.expense.providerId.required
                                    "
                                >
                                    Specifica furnizorul.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div
                        class="field is-horizontal"
                        v-show="expense.paymentType != 'Numerar'"
                    >
                        <div class="field-label is-normal">
                            <label class="label">Nr. Document</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <p class="control">
                                    <input
                                        class="input"
                                        type="text"
                                        v-model="expense.number"
                                        placeholder="Nr. document"
                                    />
                                </p>
                                <p
                                    class="help is-danger"
                                    v-if="
                                        $v.expense.number.$dirty &&
                                        !$v.expense.number.nrIsReq
                                    "
                                >
                                    Specifica numarul documentului.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Data</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <p class="control">
                                    <b-datepicker
                                        placeholder="Data bon"
                                        v-model="expense.date"
                                        :date-formatter="dateFormatter"
                                        icon="calendar-today"
                                    ></b-datepicker>
                                </p>
                            </div>
                        </div>
                    </div>


                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Total platit</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <p class="control">
                                    <input
                                        class="input"
                                        type="number"
                                        step="0.01"
                                        v-model="expense.amount"
                                        placeholder="Total cu tva"
                                    />
                                </p>
                                <p
                                    class="help is-danger"
                                    v-if="
                                        $v.expense.amount.$dirty &&
                                        !$v.expense.amount.required
                                    "
                                >
                                    Specifica total cu tva.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Detalii</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <p class="control">
                                    <textarea
                                        class="textarea"
                                        v-model="expense.details"
                                        placeholder="informatii suplimentare"
                                    ></textarea>
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <button
                        class="button"
                        type="button"
                        @click="$parent.close()"
                    >
                        Renunta
                    </button>
                    <button
                        class="button is-primary"
                        v-bind:class="{ 'is-loading': isSaving == true }"
                    >
                        <span class="icon is-small">
                            <i class="fa fa-save"></i>
                        </span>
                        <span>Salveaza</span>
                    </button>
                </footer>
            </div>
        </form>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

import { required } from "vuelidate/lib/validators";
import LoadingInfo from "@/components/LoadingInfo";
import ProviderForm from "@/components/ProviderForm";

const nrIsReq = (value, vm) => {
    if (vm) {
        var eq = vm.paymentType.toLowerCase() == "numerar";
        return eq ? true : (value || "").length > 0;
    }
    return true;
};

export default {
    name: "ExpenseForm",
    props: ["expenseId", "reload"],
    components: { LoadingInfo },
    computed: {
        ...mapState(["eTypes", "pTypes"]),
        ...mapGetters(["vehiclesList", "isLoading"]),
        filteredProviders() {
            return this.allProviders || [];
        },
    },
    data: function () {
        return {
            query: "",
            isSaving: false,
            providerSearch: "",
            isLoadingProviders: false,
            allProviders: [],
            debounceTimer: null,
            expense: {
                expenseTypeId: "",
                paymentType: "",
                number: "",
                date: new Date(),
                vehicleId: "",
                amount: null,
                details: "",
                provider: "",
                providerId: null,
            },
        };
    },
    validations: {
        expense: {
            number: { nrIsReq },
            paymentType: { required },
            expenseTypeId: { required },
            amount: { required },
            vehicleId: { required },
            providerId: { required },
        },
    },
    methods: {
        ...mapActions([
            "saveExpense",
            "loadDashboard",
            "loadExpenses",
            "loadExpense",
            "loadInitialWithPromise",
            "loadProvidersList",
        ]),
        dateFormatter(dt) {
            return dt.toLocaleDateString("ro-RO");
            //return dt.toLocaleDateString('ro-RO');
        },
        async loadAllProviders(filter = "") {
            this.isLoadingProviders = true;
            try {
                const providers = await this.loadProvidersList(filter);
                this.allProviders = providers || [];
            } catch (err) {
                console.error("Error loading providers:", err);
                this.allProviders = [];
            } finally {
                this.isLoadingProviders = false;
            }
        },
        onProviderTyping(text) {
            // Caută doar după minim 3 caractere
            if (text && text.length >= 3) {
                clearTimeout(this.debounceTimer);
                this.debounceTimer = setTimeout(() => {
                    this.loadAllProviders(text);
                }, 300);
            } else {
                // Dacă sunt mai puțin de 3 caractere, golește lista
                this.allProviders = [];
            }
        },
        onProviderEnter() {
            // La Enter, caută indiferent de numărul de caractere
            if (this.providerSearch && this.providerSearch.length > 0) {
                this.loadAllProviders(this.providerSearch);
            }
        },
        onProviderSelect(option) {
            if (option) {
                this.expense.provider = option.name;
                this.expense.providerId = option.id;
            }
        },
        addNewProvider() {
            this.$buefy.modal.open({
                parent: this,
                component: ProviderForm,
                hasModalCard: true,
                canCancel: true,
                props: {
                    reload: this.onProviderAdded,
                    initialName: this.providerSearch || ""
                },
            });
        },
        async onProviderAdded(newProvider) {
            // Reîncarcă lista de furnizori după ce s-a adăugat unul nou
            await this.loadAllProviders("");
            
            // Selectează automat furnizorul nou adăugat
            if (newProvider && newProvider.name) {
                this.providerSearch = newProvider.name;
                this.expense.provider = newProvider.name;
                this.expense.providerId = newProvider.id;
            }
        },
        save() {
            //todo: validate
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.isSaving = !this.isSaving;
                this.saveExpense(this.expense)
                    .then((resp) => {
                        this.reload();
                        // this.loadExpenses();
                        //  this.loadDashboard();
                        this.$parent.close();
                        this.isSaving = !this.isSaving;
                    })
                    .catch((err) => {
                        console.error("error: " + err);
                        this.isSaving = !this.isSaving;
                    });
            }
        },
        load(id) {
            this.loadExpense(id)
                .then((resp) => {
                    this.expense = resp.data;
                    this.expense.date = new Date(this.expense.date);
                    // Setează furnizorul în autocomplete din datele primite de la backend
                    // Backend-ul trimite provider (nume) și providerId
                    if (this.expense.provider) {
                        this.providerSearch = this.expense.provider;
                    }
                })
                .catch((err) => console.log("error loading expense:", err));
        },
    },
    mounted() {
        this.loadInitialWithPromise().then(() => {
            var id = this.expenseId;
            if (this.vehicleId) this.expense.vehicleId = this.vehicleId;
            if (id > 0) {
                this.load(id);
            }
        });
    },
};
</script>
